import { NotInterestedReason } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'

export type NotInterestedReasonOption = {
  value: NotInterestedReason
  label: string
}

// Sorted by the label the user reads so the dropdown stays alphabetical even
// when a label doesn't match its enum value's ordering.
export const NOT_INTERESTED_REASON_OPTIONS: NotInterestedReasonOption[] =
  Object.values(NotInterestedReason)
    .map((reason) => ({
      value: reason,
      label: formatSnakeValue(reason),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
